<ng-container *ngIf="visible$ | async">
  <ng-container *ngIf="product$ | async as product">
    <div *ngFor="let attr of product.variableVariationAttributes" class="product-variation read-only">
      <span class="product-variation-info span-separator">{{ attr.name }}</span>
      <span>{{ attr | ishVariationAttribute }}</span>
    </div>
  </ng-container>
</ng-container>
